import * as fromDatatype from '../datatype-library';

export interface bl_wf_user_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  user_type: fromDatatype.VarcharDatatypeInterface;
  username: fromDatatype.VarcharDatatypeInterface;
  login_subject: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_wf_user_hdr_RowClass
  implements bl_wf_user_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  user_type: fromDatatype.VarcharDatatypeInterface;
  username: fromDatatype.VarcharDatatypeInterface;
  login_subject: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
